import useTypedFlags from "hooks/useTypedFlags";

import StackPullRequestsList from "./List";
import StackPullRequestsListLegacy from "./ListLegacy";

const StackPullRequests = () => {
  const { stackPullRequestsListRedesign } = useTypedFlags();

  if (!stackPullRequestsListRedesign) {
    return <StackPullRequestsListLegacy />;
  }

  return <StackPullRequestsList />;
};

export default StackPullRequests;
